import { alpha, Theme } from '@mui/material';
import { CSSProperties } from 'react';

/**
 * Returns common highlight styles for search term highlighting
 * Used with react-highlight-words Highlighter component
 */
export const getHighlightStyles = (theme: Theme & { sass?: { ebony?: string } }) => ({
  /**
   * Style for highlighted/marked search items
   */
  mark: {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    padding: '2px',
    borderRadius: '3px',
    fontWeight: 500,
  } as CSSProperties,

  /**
   * Style for accent-colored links
   */
  accentLink: {
    color: theme.palette.primary.main,
  } as CSSProperties,
});

export type HighlightStyles = ReturnType<typeof getHighlightStyles>;
